export const PaymentProvidersEnum = {
  Razor: 'RAZORPAY',
  Ios: 'IOS',
  All: 'none',
};

export const PaymentProvidersOptions = [
  { label: 'All', value: PaymentProvidersEnum.All },
  { label: 'Razor Pay', value: PaymentProvidersEnum.Razor },
  { label: 'Ios', value: PaymentProvidersEnum.Ios },
];
